import type { Booking } from '@/entities/bookings/booking.entity';
import { CounterpartyType, type BookingLedgerCostBreakdownDto } from '@carvia/ros-client-types';
import { toRef, type MaybeRefOrGetter } from '@vueuse/core';
import { computed } from 'vue';
import { EPSILON } from '@/constants';

const COUNTERPARTY_ORDER = [
  CounterpartyType.CUSTOMER,
  CounterpartyType.AGENCY,
  CounterpartyType.OTHER,
] as const;

export const useVisibleBookingCounterparties = (
  booking: MaybeRefOrGetter<Booking | undefined>,
  breakdown?: MaybeRefOrGetter<BookingLedgerCostBreakdownDto | undefined>,
) => {
  const bookingRef = toRef(booking);
  const breakdownRef = toRef(breakdown);

  const visibleCounterpartyTypes = computed(() =>
    COUNTERPARTY_ORDER.filter((counterpartyType) => {
      const currentBooking = bookingRef.value;
      if (!currentBooking) {
        return false;
      }

      const balance = currentBooking.currentBalance?.[counterpartyType] ?? 0;
      const hasBalance = Math.abs(balance) > EPSILON;
      const hasLines = (breakdownRef.value?.[counterpartyType]?.lines.length ?? 0) > 0;

      if (counterpartyType === CounterpartyType.CUSTOMER) {
        return true;
      }

      return hasBalance || hasLines;
    }),
  );

  return { visibleCounterpartyTypes };
};
